"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));

var _Fade = _interopRequireDefault(require("../fade/Fade"));

var BaseSpinner = function BaseSpinner(_ref) {
  var isDoubleSized = _ref.isDoubleSized,
      isFullScreen = _ref.isFullScreen,
      isInverse = _ref.isInverse;
  var hasDoubleSized = isDoubleSized || isFullScreen;
  var baseSpinnerClasses = (0, _classnames.default)('spinner', hasDoubleSized && 'double', isInverse && 'inverse');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: baseSpinnerClasses
  }, /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", null));
};

var Spinner = function Spinner(props) {
  var text = props.text,
      isInverse = props.isInverse,
      isFullSized = props.isFullSized,
      isFullScreen = props.isFullScreen,
      show = props.show,
      isInline = props.isInline;
  var spinnerWrapperClasses = (0, _classnames.default)('spinnerInfoBox', isFullSized && 'fullsized', isFullScreen && 'fullscreen', 'display-flex justify-content-center align-items-center height-100pct');

  if (isInline) {
    return /*#__PURE__*/_react.default.createElement(BaseSpinner, props);
  }

  var wrappedSpinner = /*#__PURE__*/_react.default.createElement("div", {
    className: spinnerWrapperClasses
  }, /*#__PURE__*/_react.default.createElement(BaseSpinner, props), text && /*#__PURE__*/_react.default.createElement("div", {
    className: 'spinnerText'
  }, text));

  if (!(0, _isNil.default)(show) && (isFullScreen || isFullSized)) {
    return /*#__PURE__*/_react.default.createElement(_Fade.default, {
      in: show,
      timeout: 100,
      mountOnEnter: true,
      unmountOnExit: true
    }, wrappedSpinner);
  }

  return wrappedSpinner;
};

Spinner.defaultProps = {
  isInverse: false,
  isFullSized: false,
  isFullScreen: false,
  isDoubleSized: false,
  isInline: false,
  show: false
};
Spinner.propTypes = {
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  isInverse: _propTypes.default.bool,
  isFullSized: _propTypes.default.bool,
  isFullScreen: _propTypes.default.bool,
  isDoubleSized: _propTypes.default.bool,
  isInline: _propTypes.default.bool,
  show: _propTypes.default.bool
};
var _default = Spinner;
exports.default = _default;